/**
 * Note: the SG-RT utility class may differ greatly from the Player.
 * TODO: Compare and unify
 */

/**
 * SGMCLIB - Change the imports below to allow sgmc.min.js to build, until better integrated
 * 
 * //import bowser from 'bowser';
 * import { SGMessagingClientF } from '@sg/PortingSpace/SGMessagingClientPure';
 * 
 */

import bowser from 'bowser';
import { SGMessagingClientF } from '@sg/PortingSpace/SGMessagingClientPure';

export class SGClock
{
    private offset: number;

    constructor()
    {
        this.updateOffset();
    }

    updateOffset()
    {
        this.offset = Date.now() - Math.round(performance.now());
    }

    now() {
        return this.offset + Math.round(performance.now());
    }
}

// Forward references are required when declaring this object.
export let LocalClock = new SGClock();

export class AutoResetEvent
{
    private _WaitingResolvers: Function[];
    private _IsSignaled: boolean;

    constructor(initialState = false) {
        this._WaitingResolvers = [];
        this._IsSignaled = initialState;
    }

    async waitOne() {
        if (this._IsSignaled) {
            this._IsSignaled = false;
            return;
        }
        return new Promise(resolve => {
            this._WaitingResolvers.push(resolve);
        });
    }
    set() {
        if (this._WaitingResolvers.length > 0) {
            const resolve = this._WaitingResolvers.shift();
            if (resolve) {
                resolve();
            }
        }
        else {
            this._IsSignaled = true;
        }
    }
    reset() {
        this._IsSignaled = false;
    }
}

/**
 * Accepts a time series and provides an averaged value over a window.
 */
export class Smoother
{
    private _value: number;
    private _queue: number[];
    private _windowSize: number;
    get Value() { return this._value; }
    get WindowSize() { return this._windowSize; }

    // How many 
    constructor(windowSize = 30)
    {
        // TODO: look into how to exit here gracefully without a throw which could cause issues in a customers hands.
        //if (windowSize <= 0) throw new Error("Smoother must have a window size greater than zero");

        this._value = 0;
        this._queue = [];
        this._windowSize = windowSize;
    }

    // Push in the next tick
    // TODO: accept variable number of parameters
    Update(nextValue:string | number = 0) {
        nextValue = parseFloat(nextValue as string); // TODO: fix typing here.
        if (isNaN(nextValue)) return; // ignore invalid numbers

        if (this._queue.length >= this._windowSize - 1) {
            let toRemove = this._queue.length - this._windowSize + 1;
            while (toRemove-- > 0) {
                this._queue.shift();
            }
        }
        this._queue.push(nextValue);

        // re-adjust as we go and accept error accumulation?
        this.Recalc();

        return this._value;
    }

    // Force a recalculation of the average
    Recalc() {
        if (this._windowSize <= 0) {
            return undefined;
        }

        let result = this._queue.reduce((sum, x) => sum + x, 0.0);
        result /= this._queue.length;
        this._value = result;

        return result;
    }
}

export class SGUtility
{
    static DEBUG_MESSAGE_SERVER = "atl.srv009.streaming.global";
    //static DEBUG_MESSAGE_SERVER = "dcatl1rts02.streaming.global:45084";
    static isDesktopBrowserCached: boolean | null = null;

    static DEBUG_MESSAGE_SERVER_CHANNEL = "videojsDebug";
    static isSafariBasedBrowserCached = null;
    static recentCacheForConsoleSink = [];
    static consoleOutputCallback = null;

    static toBoolean(value) {
        if (!value) {
            return false;
        }
        let compareValue = value.toString().toLowerCase();
        switch (compareValue) {
            case "":
            case "0":
            case "false":
            case "no":
                return false;
            case "1":
            case "true":
            case "yes":
                return true;
        }
        let parsed = parseInt(compareValue, 10);
        if (isNaN(parsed)) {
            return false;
        }
        return (parsed != 0);
    }
    ;
    static toNumber(value, defaultValue = 0) {
        if (value == null || value == undefined) {
            return defaultValue;
        }
        let result = Number(value);
        if (isNaN(result)) {
            return defaultValue;
        }
        return result;
    }
    ;
    static getURLQueryParam(name, abbreviatedName, defaultValue) {
        let params = new URLSearchParams(self.location.search.replaceAll(';', '&'));
        if (name) {
            let value = params.get(name);
            if (value != null) {
                return value;
            }
        }
        if (abbreviatedName) {
            let value = params.get(abbreviatedName);
            if (value != null) {
                return value;
            }
        }
        return defaultValue !== undefined ? defaultValue : null;
    }
    ;
    static loadJavascript(sourceFile) {
        if (self["importScripts"]) {
            return self.importScripts(sourceFile);
        }
        if (self["document"]) {
            let script = self.document.createElement('script');
            script.type = 'text/javascript';
            script.src = sourceFile;
            let head = self.document.getElementsByTagName('head')[0];
            head.appendChild(script);
        }
    }
    ;
    // SGMCLIB - Comment out this method to compile sgmc.min.js (because bowser was removed)
    //static isDesktopBrowser() {
    //    // Only execute this once, cache result
    //    if (SGUtility.isDesktopBrowserCached === null) {
    //        const parsedResult = bowser.parse(self.navigator.userAgent);
    //        SGUtility.isDesktopBrowserCached = parsedResult.platform.type === "desktop";
    //    }
    //    return SGUtility.isDesktopBrowserCached;
    //}
    ;
    static isSafariBasedBrowser() {
        // Only execute this once, cache result
        if (SGUtility.isSafariBasedBrowserCached === null) {
            const ua = self.navigator.userAgent.toLowerCase();
            if (ua.indexOf("safari") !== -1 || ua.indexOf("firefox") !== -1) {
                if (ua.indexOf("chrome") > -1) {
                    // Not sure why this check was in.
                    SGUtility.isSafariBasedBrowserCached = false;
                }
                else {
                    SGUtility.isSafariBasedBrowserCached = true;
                }
            }
            else {
                SGUtility.isSafariBasedBrowserCached = false;
            }
        }
        return SGUtility.isSafariBasedBrowserCached;
    }
    ;
    static getCookie(name) {
        if (!self["document"]) {
            return undefined;
        }
        const matches = self.document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }
    ;
    static setCookie(name, value, options) {
        if (!self["document"]) {
            return;
        }
        options.path = "/";
        options.secure = true;
        if (options.expires instanceof Date) {
            options.expires = options.expires.toUTCString();
        }
        let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
        for (let optionKey in options) {
            updatedCookie += "; " + optionKey;
            const optionValue = options[optionKey];
            if (optionValue !== true) {
                updatedCookie += "=" + optionValue;
            }
        }
        self.document.cookie = updatedCookie;
    }
    ;
    static deleteCookie(name) {
        this.setCookie(name, "", {
            "max-age": -1,
        });
    }
    ;
    static sizeToContain(width, height, maxWidth, maxHeight) {
        const newSize = {
            width: 0,
            height: 0
        };
        // Stretch the width to match max size and adjust height to maintain aspect ratio
        newSize.width = maxWidth;
        newSize.height = height / width * maxWidth;
        // If necessary, constrain the height to maxHeight and adjust width to maintain aspect ratio
        if (newSize.height > maxHeight) {
            newSize.width = newSize.width * maxHeight / newSize.height;
            newSize.height = maxHeight;
        }
        newSize.width = Math.floor(newSize.width);
        newSize.height = Math.floor(newSize.height);
        return newSize;
    }
    ;
    static supportsMediaSourceExtensions() {
        if (self["MediaSource"]) {
            return true;
        }
        return false;
    }
    static sendAjaxRequest(url, type, onload) {
        const request = new XMLHttpRequest();
        request.responseType = type;
        request.onload = onload;
        request.open("GET", url, true);
        request.send();
    }
    ;
    static installConsoleOutputCallback(callback) {
        SGUtility.consoleOutputCallback = callback;
        let cached = SGUtility.recentCacheForConsoleSink;
        if (cached.length > 0) {
            for (let i = 0; i < cached.length; i++) {
                callback(cached[i]);
            }
            SGUtility.recentCacheForConsoleSink = [];
        }
    }
    ;
    static hookConsoleOutput(allowConsoleOutput, forwardToDebugChannel, isDebug, logFilter) {
        let client;
        let cachedLogsArray = [];
        let recentConsoleOutput = [];
        function handleConsoleOutput(originalOutputFunc, originalOutputArgs) {
            if (forwardToDebugChannel || isDebug) {
                let argString = "";
                for (let index = 0; index < originalOutputArgs.length; index++) {
                    const element = originalOutputArgs[index];
                    if (index != 0) {
                        argString += " ";
                    }
                    argString += element;
                }
                if (forwardToDebugChannel) {
                    if (client && client.connected) {
                        client.sendDebug(SGUtility.DEBUG_MESSAGE_SERVER_CHANNEL, argString);
                    }
                    else {
                        cachedLogsArray.push(argString);
                    }
                }
                if (SGUtility.consoleOutputCallback) {
                    SGUtility.consoleOutputCallback(argString);
                }
                else {
                    if (SGUtility.recentCacheForConsoleSink.length >= 10) {
                        SGUtility.recentCacheForConsoleSink = SGUtility.recentCacheForConsoleSink.slice(1);
                    }
                    SGUtility.recentCacheForConsoleSink.push(argString);
                }
            }
            if (allowConsoleOutput && originalOutputFunc) {
                if (logFilter && originalOutputArgs && !originalOutputArgs[0].match(logFilter)) 
                    originalOutputFunc.apply(console, originalOutputArgs);
            }
        }
        ;
        let _error = console.error;
        console.error = function (...data) {
            handleConsoleOutput(_error, arguments);
        };
        let _log = console.log;
        console.log = function (...data) {
            handleConsoleOutput(_log, arguments);
        };
        let _warn = console.warn;
        console.warn = function (...data) {
            handleConsoleOutput(_warn, arguments);
        };
        let _info = console.info;
        console.info = function (...data) {
            handleConsoleOutput(_info, arguments);
        };
        let _debug = console.debug;
        console.debug = function (...data) {
            handleConsoleOutput(_debug, arguments);
        };
        if (forwardToDebugChannel) {
            client = new SGMessagingClientF(SGUtility.DEBUG_MESSAGE_SERVER);
            client.createClient();
            client.setClusterUrl(SGUtility.DEBUG_MESSAGE_SERVER);
            client.connect();
            client.onConnected = function () {
                client.sendDebug(SGUtility.DEBUG_MESSAGE_SERVER_CHANNEL, `Debug console initialized. User-agent: ${self.navigator.userAgent}`);
                for (let index = 0; index < cachedLogsArray.length; index++) {
                    const element = cachedLogsArray[index];
                    client.sendDebug(SGUtility.DEBUG_MESSAGE_SERVER_CHANNEL, element);
                }
            };
        }
    }
    static escapeHtmlEntities(text) {
        return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    static deobfuscateFragment(fragmentBytes) {
        let deobfuscateNeeded = false;
        if (fragmentBytes && fragmentBytes.length >= 28) {
            // confirm this is a Streaming Global file by signature and replace the ftyp box
            if (fragmentBytes[0] == 'S'.charCodeAt(0) &&
                fragmentBytes[1] == 't'.charCodeAt(0) &&
                fragmentBytes[2] == 'r'.charCodeAt(0) &&
                fragmentBytes[3] == 'e'.charCodeAt(0) &&
                fragmentBytes[4] == 'a'.charCodeAt(0) &&
                fragmentBytes[5] == 'm'.charCodeAt(0) &&
                fragmentBytes[6] == 'i'.charCodeAt(0) &&
                fragmentBytes[7] == 'n'.charCodeAt(0) &&
                fragmentBytes[8] == 'g'.charCodeAt(0) &&
                fragmentBytes[9] == 'G'.charCodeAt(0) &&
                fragmentBytes[10] == 'l'.charCodeAt(0) &&
                fragmentBytes[11] == 'o'.charCodeAt(0) &&
                fragmentBytes[12] == 'b'.charCodeAt(0) &&
                fragmentBytes[13] == 'a'.charCodeAt(0) &&
                fragmentBytes[14] == 'l'.charCodeAt(0) &&
                fragmentBytes[15] == 'D'.charCodeAt(0) &&
                fragmentBytes[16] == 'a'.charCodeAt(0) &&
                fragmentBytes[17] == 't'.charCodeAt(0) &&
                fragmentBytes[18] == 'a'.charCodeAt(0) &&
                fragmentBytes[19] == 'F'.charCodeAt(0) &&
                fragmentBytes[20] == 'm'.charCodeAt(0) &&
                fragmentBytes[21] == 't'.charCodeAt(0)) {
                deobfuscateNeeded = true;
                // confirm this is an obfuscated MP4 file
                if (fragmentBytes[22] == '0'.charCodeAt(0) &&
                    fragmentBytes[23] == '1'.charCodeAt(0)) {
                    // put size bytes back at beginning of ftyp box
                    fragmentBytes[0] = fragmentBytes[24];
                    fragmentBytes[1] = fragmentBytes[25];
                    fragmentBytes[2] = fragmentBytes[26];
                    fragmentBytes[3] = fragmentBytes[27];
                    // replace MP4 ftyp box
                    fragmentBytes[4] = 'f'.charCodeAt(0);
                    fragmentBytes[5] = 't'.charCodeAt(0);
                    fragmentBytes[6] = 'y'.charCodeAt(0);
                    fragmentBytes[7] = 'p'.charCodeAt(0);
                    // replace MP4 ftyp major brand
                    fragmentBytes[8] = 'm'.charCodeAt(0);
                    fragmentBytes[9] = 'p'.charCodeAt(0);
                    fragmentBytes[10] = '4'.charCodeAt(0);
                    fragmentBytes[11] = '2'.charCodeAt(0);
                    // replace MP4 ftyp minor version
                    fragmentBytes[12] = 0;
                    fragmentBytes[13] = 0;
                    fragmentBytes[14] = 0;
                    fragmentBytes[15] = 0;
                    // replace MP4 ftyp minor brand
                    fragmentBytes[16] = 'm'.charCodeAt(0);
                    fragmentBytes[17] = 'p'.charCodeAt(0);
                    fragmentBytes[18] = '4'.charCodeAt(0);
                    fragmentBytes[19] = '2'.charCodeAt(0);
                    // zero out rest of ftyp box
                    fragmentBytes[20] = 0;
                    fragmentBytes[21] = 0;
                    fragmentBytes[22] = 0;
                    fragmentBytes[23] = 0;
                    fragmentBytes[24] = 0;
                    fragmentBytes[25] = 0;
                    fragmentBytes[26] = 0;
                    fragmentBytes[27] = 0;
                }
            }
        }
        return deobfuscateNeeded;
    }
    static zeroPadNumberString(num, minDigits) {
        let result = num.toString();
        if (result.length < minDigits) {
            result = "0".repeat(minDigits - result.length) + result;
        }
        return result;
    }
    static setElementInnerHtmlByID(id, html) {
        let el = document.getElementById(id);
        if (el) {
            el.innerHTML = html;
            return true;
        }
        return false;
    }
    static bytesToMegaBytes(numBytes, numDecimals = 3) {
        return (numBytes / 1000000).toFixed(numDecimals);
    }
    ;
    static getMemoryUsageString() {
        let output = "";
        if (window["performance"] && window.performance["memory"]) {
            output += `jsHeapSizeLimit: ${SGUtility.bytesToMegaBytes(window.performance["memory"].jsHeapSizeLimit)} MB\n`;
            output += `totalJSHeapSize: ${SGUtility.bytesToMegaBytes(window.performance["memory"].totalJSHeapSize)} MB\n`;
            output += `usedJSHeapSize: ${SGUtility.bytesToMegaBytes(window.performance["memory"].usedJSHeapSize)} MB\n`;
        }
        return output;
    }
    static trimStringEnd(input, pattern) {
        let patternLength = pattern.length;
        if (patternLength <= 0) {
            return;
        }
        let output = input;
        while (output.length >= patternLength && output.substring(output.length - patternLength) == pattern) {
            output = output.substring(0, output.length - patternLength);
        }
        return output;
    }
    ;
    static CSharpTicksToUtcMS(ticks) {
        // handle browsers with smaller number resolution by reordering 
        ticks /= 10000;
        return (ticks - 62135596800000);
    }

    // Returns a string
    static UtcMSToCSharpTicks(millis = 0) {
        millis += 62135596800000; // add the dotnet time origin, in milliseconds
        return millis * 10000; // timescale
    }

    static getDefaultUITimeString(utcTimeMS) {
        let timeString = new Date(utcTimeMS).toLocaleTimeString().replace(/[ ]+(PM|AM)/, "");
        // If we choose to zero pad the hour
        // if (timeString.match(/^[0-9]\:/)) {
        //    timeString = "0" + timeString;
        // }
        return timeString;
    }
}

// In powers of 10^3k
const unitPrefixMap: Record<number, string> = {
    0: "",
    1: "K",
    2: "M",
    3: "G",
    4: "T",
    5: "P",
    6: "E",
    // I wish we had the problem of needing higher unit prefixes, but for fun
    7: "Z", // zetta
    8: "Y", // yotta
    9: "R", // ronna
    10: "Q", // queta
};

/**
 * Formats a bandwidth number as a scaled value with proper units for display in a tab.
 * 
 * @param bytesPerSecond
 * @returns a formatted string for display
 */
export function formatBandwidthForTabDisplay(bytesPerSecond: number): string
{
    const sign = Math.sign(bytesPerSecond);
    let value = Math.abs(bytesPerSecond);
    let result: string;
    let scale: number = 0;

    if (value < 1)
    {
        return "--";
    }
    else if (value < 1_000)
    {
        // It's not strictly needed to break this out
        value = Math.round(value * 10) / 10;
        result = value.toString();
    }
    else
    {
        // use the number of digits to determine the proper units scale (kilo, mega, etc.)
        scale = Math.floor(Math.log10(value) / 3);
        // round to one significant digit (the .0 will be dropped for us using .toString())
        value = Math.round(value / (10 ** (scale * 3 - 1))); // e.g. 100 for KB so we keep the extra decimal digit
        value /= 10; // now adjust down.
        result = value.toString();
    }

    return `${sign < 0 ? "-" : ""}${result} ${unitPrefixMap[scale]}B/s`;
}

/**
 * Formats a string with the correct SI prefix for the number given, if that number
 * was scaled to the right place.
 * 
 * @param value number in base units
 * @param baseUnit defaults to "B/s", bytes per second
 * @returns A unit string with the proper SI prefix prepended, e.g. MB/s
 */
export function formatScaledUnits(value: number, baseUnit: string = "B/s")
{
    value = Math.abs(value);
    const scale = Math.floor(Math.log10(value) / 3);
    return unitPrefixMap[scale] + baseUnit;
}

// tests
/*
const tests: number[] = [
    -0.1,
    1.0,
    1.1,
    12.049,
    123.099,
    1234.1,
    -5142.0,
    19_278_572.55,
    992_091_099.29292,
    29_872_985_792_875.1,
    12_119_872_985_792_875.1,
];

for(let item of tests) {
    console.log(`test -> ${formatBandwidthForTabDisplay(item)}`);
}
*/